import { StrategyTemplate } from '../types';

export const STRATEGY_TEMPLATES: StrategyTemplate[] = [
  {
    id: 'synthetic-usd',
    label: 'Synthetic USD',
    sentiment: 'neutral',
    defaults: {
      name: 'Synthetic USD',
      accountInformation: {
        tokenBalance: '1',
        usdBalance: '0',
      } as any,
      execution: {
        executionTime: '15',
        whenExecutionWeekdaysDays: ['friday'],
        optionsNotionalScaled: true,
        notionalScalingType: 'PV',
      } as any,
      hedging: {
        frequency: '1',
      } as any,
    },
  },
  {
    id: 'covered-call-w1x30c',
    label: 'Covered Call (W1x30C)',
    sentiment: 'neutral',
    defaults: {
      name: 'Covered Call (W1x30C)',
      accountInformation: {
        tokenBalance: '1',
        usdBalance: '0',
      } as any,
      execution: {
        executionTime: '15',
        whenExecutionWeekdaysDays: ['friday'],
        optionsNotionalScaled: true,
        notionalScalingType: 'PV',
      } as any,
      hedging: {
        frequency: '0',
      } as any,
      portfolio: {
        instruments: [{ tenor: 'W1', notional: '-1', deltaOrStrike: '30C' }],
      },
    },
  },
  {
    id: 'hedged-sell-1mx25rr',
    label: 'Hedged Sell 1Mx25RR',
    sentiment: 'neutral',
    defaults: {
      name: 'Hedged Sell 1Mx25RR',
      accountInformation: {
        tokenBalance: '0',
        usdBalance: '100000',
      } as any,
      execution: {
        executionTime: '15',
        whenExecutionWeekdays: false,
        whenExecutionAverageIn: true,
        optionsNotionalScaled: true,
        notionalScalingType: 'PV',
      } as any,
      hedging: {
        frequency: '1',
      } as any,
      portfolio: {
        instruments: [
          { tenor: '1M', notional: '-1', deltaOrStrike: '15C' },
          { tenor: '1M', notional: '1', deltaOrStrike: '15P' },
        ],
      },
    },
  },
  {
    id: 'short-strangle-delta-threshold',
    label: 'Short Strangle + Delta Threshold',
    sentiment: 'neutral',
    defaults: {
      name: 'Short Strangle + Delta Threshold',
      accountInformation: {
        tokenBalance: '0',
        usdBalance: '100000',
      } as any,
      execution: {
        executionTime: '15',
        whenExecutionWeekdays: false,
        whenExecutionAverageIn: true,
        optionsNotionalScaled: true,
        notionalScalingType: 'PV',
      } as any,
      hedging: {
        frequency: '1',
        deltaThreshold: true,
        deltaThresholdValue: '0.5',
      } as any,
      portfolio: {
        instruments: [
          { tenor: '1W', notional: '-1', deltaOrStrike: '30C' },
          { tenor: '1W', notional: '-1', deltaOrStrike: '30P' },
        ],
      },
    },
  },
];
